// Scroll smoothly to the quote section and focus the Name field so
// the visitor can start typing immediately.
export function scrollToQuote(e) {
    if (e && e.preventDefault) e.preventDefault();
    const section = document.getElementById("quote");
    if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // After the scroll settles, focus the name input.
    setTimeout(() => {
        const input = document.querySelector('[data-testid="quote-input-name"]');
        if (input && typeof input.focus === "function") {
            input.focus({ preventScroll: true });
        }
    }, 750);
}
